// extracted by mini-css-extract-plugin
module.exports = {"statement":"statement-module--statement--1JrFE"};